import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';


const IconNotification = ({ width = 16, height = 16, color = colors.primaryInfo }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 14 16' fill={color}>
        <path d='M11.925 10.128C11.5655 9.80021 11.3409 9.35033 11.295 8.866V5.892C11.3102 4.80429 10.9632 3.74241 10.3088 2.87346C9.65437 2.00452 8.7296 1.37782 7.68 1.092C7.68 0.802384 7.56495 0.524629 7.36016 0.319839C7.15537 0.11505 6.87762 0 6.588 0C6.29838 0 6.02063 0.11505 5.81584 0.319839C5.61105 0.524629 5.496 0.802384 5.496 1.092C4.44659 1.37801 3.52204 2.00478 2.86781 2.87371C2.21358 3.74265 1.86679 4.80442 1.882 5.892V8.866C1.83608 9.35033 1.61149 9.80021 1.252 10.128L0 11.379V13.262H4.706C4.706 13.7613 4.90433 14.2401 5.25737 14.5931C5.61041 14.9462 6.08923 15.1445 6.5885 15.1445C7.08777 15.1445 7.56659 14.9462 7.91963 14.5931C8.27267 14.2401 8.471 13.7613 8.471 13.262H13.176V11.379L11.925 10.128Z' fill='#0051FF' />
    </svg>;
};

IconNotification.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};
export default IconNotification;
